/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/featuresSection.config.json';
import { useProduct } from '../provider';

export interface IFeatureSectionMethods extends IPluginMethodMap {
  getFeatureSectionProps(args: any): Promise<any>;
}

export class FeatureSectionService implements IAgentPlugin {
  readonly methods: IFeatureSectionMethods;

  constructor() {
    this.methods = {
      getFeatureSectionProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const { prodId, auth } = useProduct();
    return {
      productData: {
        ...(config || {}),
        auth:
          auth === '200'
            ? config?.lockIcon
            : auth === '500'
            ? config?.unlockIcon
            : null,
        badgeCarouselItems: this.getBadgeCarousel(config?.batchCredentials),
        TIME_LINE_ITEMS: this.getTimeLineItems(config?.TIME_LINE_ITEMS),
      },
    };
  }

  private getBadgeCarousel(data: any) {
    let _temp: any = [];
    Array.isArray(data) &&
      data.forEach((element) => {
        _temp.push({
          batchData: element,
          key: element?.batchId,
          titleImage: element?.logo,
          title: element?.name,
        });
      });

    return _temp;
  }

  private getTimeLineItems(data: any) {
    let _temp: any = [];
    Array.isArray(data) &&
      data.forEach((element) => {
        _temp.push({
          ...element,
          children: this.getChildren(element?.children),
        });
      });
    console.log(`_temp ::`, _temp);
    return _temp;
  }

  private getChildren(data: any) {
    let _temp: any = [];
    Array.isArray(data) &&
      data.forEach((element) => {
        _temp.push({
          ...element,
          badgeCarouselItems: element?.batchCredentials
            ? this.getBadgeCarousel(element?.batchCredentials)
            : [],
        });
      });
    return _temp;
  }
}
